import {
  transform, isPlainObject, isArray, snakeCase, isFunction, get,
} from 'lodash';

export const transformKeysFromCamelCaseToSnakeCase = (obj) => {
  if (!isPlainObject(obj)) {
    return obj;
  }

  return transform(obj, (result, value, key) => {
    let transformedValue = value;

    if (isArray(value)) {
      transformedValue = value.map(transformKeysFromCamelCaseToSnakeCase);
    } else if (isPlainObject(value)) {
      transformedValue = transformKeysFromCamelCaseToSnakeCase(value);
    }

    result[snakeCase(key)] = transformedValue;

    return result;
  }, {});
};

export const callIfPossible = (target, args, path) => {
  const func = path ? get(target, path) : target;

  return isFunction(func) ? func(args) : target;
};
